import {Component, OnInit} from "@angular/core";
import {MatDialog, MAT_DIALOG_DATA} from "@angular/material";

import {AddProjectMapStepDialogComponent} from "../add-project-map-step-dialog/add-project-map-step-dialog.component";
import {ProjectMapFieldComponent} from "../../project-map/project-map-field/project-map-field.component";
import {EditProjectMapStepDialogComponent} from "../edit-project-map-step-dialog/edit-project-map-step-dialog.component";
import {ProjectMapStepCategoryComponent} from "../../project-map/project-map-step-category/project-map-step-category.component";

import {AdminService, AlertService, CommonService} from "../../../_services/";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {Subscription} from "rxjs";

@Component({
  selector: "app-project-map-step",
  templateUrl: "./project-map-step.component.html",
  styleUrls: ["./project-map-step.component.scss"],
})
export class ProjectMapStepComponent implements OnInit {
  projectMapStep: any[] = [];
  submitted: Boolean = false;
  emailSettingsForm: FormGroup;
  recipientList: any[] = [];
  emailRecipientId: string;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;

  constructor(
    public dialog: MatDialog,
    private _common: CommonService,
    private _admin: AdminService,
    private _alert: AlertService,
    private fb: FormBuilder,
    private _toastr: ToastrService
  ) {}

  ngOnInit() {
    this.getProjectMapStepList();
    this.emailSettingsForm = this.fb.group({
      id: [null, [Validators.required, Validators.maxLength(50)]],
      live_receipients: [null, []],
      dev_receipients: [null, []],
      dev_designers: [null, []],
    });

    this.getEmailSettingsList();
  }

  openAddNewProjectMapStepDialog() {
    let dialogRef = this.dialog.open(AddProjectMapStepDialogComponent, {
      width: "auto",
    });

    dialogRef.afterClosed().subscribe((response) => {});
  }

  getProjectMapStepList() {
    this._common.showLoader(true);
    this.subscription = this._admin.getProjectMapList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.projectMapStep = result;
      },
      (err) => {
        this._common.showLoader(false);
        this._alert.error(
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!"
        );
      }
    );
  }

  getEmailSettingsList() {
    this._common.showLoader(true);
    this.subscription2 = this._admin.getEmailSettings().subscribe(
      (result) => {
        this.recipientList = [];
        for (let i = 0; i < result.length; i++) {
          let obj = {
            uniq_id: result[i].payload.doc.id,
            id: result[i].payload.doc.data()["id"],
            dev_designers: result[i].payload.doc
              .data()
              ["dev_designers"].split(","),
            dev_receipients: result[i].payload.doc
              .data()
              ["dev_receipients"].split(","),
            live_receipients: result[i].payload.doc
              .data()
              ["live_receipients"].split(","),
          };
          this.recipientList.push(obj);
        }
        this._common.showLoader(false);
      },
      (err) => {
        this._common.showLoader(false);
        this._toastr.error(
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!",
          "",
          {timeOut: 4000}
        );
      }
    );
  }

  // project map field
  openProjectMapFieldDialog(name, id) {
    let dialogRef = this.dialog.open(ProjectMapFieldComponent, {
      width: "auto",
      data: {
        name: name,
        id: id,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {});
  }

  // delete project map field

  deleteProjectMap(step_id) {
    this._common.showLoader(true);
    // delete project map step
    this._admin
      .deleteProjectMapStep(step_id)
      .then((res) => {
        // delete project map field
        this._admin.deleteProjectMapField(step_id).subscribe(
          (res) => {
            this._common.showLoader(false);
            this._alert.success("Project Map Step deleted successfully!");
          },
          (err) => {
            this._common.showLoader(false);
            this._alert.error(
              err.error.message ? err.error.message : "Something went wrong!"
            );
          }
        );
      })
      .catch((err) => {
        this._common.showLoader(false);
        this._alert.error(
          err.error.message ? err.error.message : "Something went wrong!"
        );
      });
  }

  // open edit project map step dialog
  openEditProjectMapDialog(id) {
    let dialogRef = this.dialog.open(EditProjectMapStepDialogComponent, {
      width: "auto",
      data: {
        id: id,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {
      // this.getUserList(localStorage.getItem('uid'))
    });
  }

  // open category listing dialog
  openProjectMapCategoryDialog(step, id) {
    let dialogRef = this.dialog.open(ProjectMapStepCategoryComponent, {
      width: "auto",
      data: {
        step,
        id,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {});
  }

  get fval() {
    return this.emailSettingsForm.controls;
  }

  onFormSubmit(): void {
    this.submitted = true;
    if (this.emailSettingsForm.invalid) {
      return;
    }
    let form = this.emailSettingsForm.value;
    this._common.showLoader(true);
    if (!this.emailRecipientId) {
      // Create Email Receipients
      this._admin
        .createEmailRecipients(form)
        .then((res) => {
          this._toastr.success("Email Recipient created successfully!", "", {
            timeOut: 4000,
          });
          this.submitted = false;
          this.emailSettingsForm.reset();
          this._common.showLoader(false);
        })
        .catch((err) => {
          this._common.showLoader(false);
          this._toastr.error(
            err.error.message ? err.error.message : "Something went wrong!",
            "",
            {timeOut: 4000}
          );
        });
    } else {
      // Update Email Receipients
      this._admin
        .updateEmailRecipients(form, this.emailRecipientId)
        .then((res) => {
          this._toastr.success("Email Recipient updated successfully!", "", {
            timeOut: 4000,
          });
          this.emailRecipientId = "";
          this.submitted = false;
          this.emailSettingsForm.reset();
          this._common.showLoader(false);
        })
        .catch((err) => {
          this._common.showLoader(false);
          this._toastr.error(
            err.error.message ? err.error.message : "Something went wrong!",
            "",
            {timeOut: 4000}
          );
        });
    }
  }

  deleteEmailRecipients(id) {
    this._common.showLoader(true);
    // delete project map step
    this._admin
      .deleteEmailRecipients(id)
      .then((res) => {
        this._toastr.success("Email Recipients deleted successfully!", "", {
          timeOut: 4000,
        });
      })
      .catch((err) => {
        this._common.showLoader(false);
        this._toastr.error(
          err.error.message ? err.error.message : "Something went wrong!",
          "",
          {timeOut: 4000}
        );
      });
  }

  editEmailRecipients(id, el: HTMLElement) {
    this._common.showLoader(true);
    this.subscription3 = this._admin.getEmailRecipient(id).subscribe(
      (result) => {
        this.emailRecipientId = result.payload.id;
        this.emailSettingsForm.patchValue({
          id: result.payload.data()["id"],
          live_receipients: result.payload.data()["live_receipients"],
          dev_receipients: result.payload.data()["dev_receipients"],
          dev_designers: result.payload.data()["dev_designers"],
        });
        // window.scrollTo(0, 0);
        el.scrollIntoView();
        this._common.showLoader(false);
      },
      (err) => {
        this._common.showLoader(false);
        this._alert.error(
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!"
        );
      }
    );
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
    if (this.subscription3) this.subscription3.unsubscribe();
  }
}
